export default "__VITE_ASSET__ClztjjZE__"